import { Typography, Stack } from "@mui/material";
import __ from "src/utils/Translations";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import DashboardTabs from "src/Pages/Company/Dashboard/components/Heading/DashboardTabs";
import useIsAhr from "src/utils/hooks/useIsAhr";

const Heading = () => {
  const companyId = useCompanyId();
  const companyName = useCompanyName();
  const isAhr = useIsAhr();

  return (
    <Stack sx={{ gap: "1.5rem" }}>
      <Stack sx={{ gap: "0.5rem" }}>
        <Typography variant="h4" sx={{ color: "text.primary" }}>
          {__("Dashboard")}
        </Typography>
        <Typography sx={{ color: "text.primary" }}>{`${__(
          "Firma"
        )} ${companyName} (ID: ${companyId})`}</Typography>
      </Stack>
      {!isAhr && <DashboardTabs />}
    </Stack>
  );
};

export default Heading;
